import { themegreen } from './color';

export const poppins300 = {
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '300',
  fontSize: '16px !important',
};

export const poppins700 = {
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '700 !important',
  fontSize: '36px !important',
};
export const paddTop10 = {
  paddingTop: '10px',
};
export const fontsize16 = {
  fontSize: '16px !important',
};
export const fontsize20 = {
  fontSize: '20px !important',
};

export const poppins400 = {
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '400 !important',
  fontSize: '16px !important',
};
export const staticCard = {
  fontFamily: 'poppins',
  padding: '10px 14px',
  height: '30px',
  display: 'flex',
  alignItems: 'center',
  marginRight: '4px',
  gap: '5px',
  fontSize: '12px',
  fontWeight: 400,
  width: 'auto',
  borderRadius: '4px',
};

export const paddingLeft4 = {
  paddingLeft: '4px',
};
export const margin10 = {
  margin: '10px',
};

export const displayInlineBlock = {
  display: 'inline-block',
};

export const poppins500 = {
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '500 !important',
  fontSize: '24px !important',
};

export const displayFlex = {
  display: 'flex',
};

export const fontWeightBold = {
  fontWeight: 'bold',
};
export const poppins600 = {
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '600 !important',
  fontSize: '15px !important',
  color: '#1E1E1E',
};
export const fontsize15 = {
  fontSize: '15px !important',
};
export const fontsize14 = {
  fontSize: '14px !important',
};
export const fontsize36 = {
  fontSize: '36px !important',
};
export const fontsize32 = {
  fontSize: '32px !important',
};
export const bgGreen = {
  color: themegreen,
};
export const fontsize10 = {
  fontSize: '10px !important',
  color: 'gray',
  marginTop: '5px',
};
export const fontsize40 = {
  fontSize: '32px !important',
};
export const fontsize12 = {
  fontSize: '10px !important',
};
export const fontsize8 = {
  fontSize: '8px !important',
  height: '22px',
};
export const fontsize31 = {
  fontSize: '9px',
  marginTop: '5px',
  marginLeft: '5px',
};
export const fontsize33 = {
  fontSize: '33px !important',
};
export const fontsize34 = {
  fontWeight: '900',
  fontSize: '17px',
};

export const fontsize38 = {
  color: 'black',
  fontSize: '13px',
  border: '1px solid gray',
  height: '25px',
  marginTop: '13px',
};
export const fontsize24 = {
  fontSize: '24px !important',
};

export const displayFlexColumn = {
  display: 'flex',
  flexDirection: 'column !important',
};

export const spaceBetween = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '92px',
};

export const menuitemfont = {
  fontSize: '14px',
  fontFamily: 'poppins',
  fontWeight: 500,
};
